import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Charts from "./Charts";
import Cards from "./Cards";
import api from "@/auth/api";
import Loader from '@/components/Loader';


function HomeDetailed() {
  const { country } = useParams();
  const navigate = useNavigate(); 
  const [chartData, setChartData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [title, setTitle] = useState();
  const [loading, setLoading] = useState(true);

  const getHomeData = async () => {
    const resp = await api.get(`/PanelHome/panel/Home?Country=${country}`);
    setCountryList(resp.data.Country.filter(f=>f !== "All"));
    setChartData(resp?.data?.result?.Chart);
    setCardData(resp?.data?.result?.Detail);
    setTitle(resp?.data?.Title);
    setLoading(false)
  };

  useEffect(() => {
    getHomeData();
  }, [country]);

  const handleCountryChange = (e) => {
    const selected = e.target.value;
    if(e.target.value==="All"){
      navigate(`/`);
      return 
    }
    if (selected) {
      navigate(`/${selected}`);
    }
  };

  return (
    <div className="pt-14 px-4">
      {/* <div className="w-full text-center mt-2 font-bold text-2xl">{country}</div> */}

      {loading &&
      <div className="flex justify-center pt-16">
        <Loader />
      </div>}
      {/* Always Show Dropdown */}
      {countryList?.length>1 ? 
      <div className="flex justify-center mt-4">
        <select
          onChange={handleCountryChange}
          value={country}
          className="border border-gray-300 px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="" disabled>
            Select a country
          </option>
          {countryList.map((c, i) => (
            <option key={i} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>:<div className="w-full text-center mt-4 text-xl">{title}</div>
}

      {/* Chart + Cards */}
      <Charts chartData={chartData} />
      <Cards cardData={cardData} />
    </div>
  );
}

export default HomeDetailed;
